var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropupBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0.666667,
    y: 0.666667,
    width: 46.6667,
    height: 46.6667,
    rx: 10,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 -2.91409e-08 2.91409e-08)",
    fill: "white",
    stroke: "#E4E7EB",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7247 27.344C17.3616 26.981 17.3584 26.3892 17.7215 26.0261L23.0024 20.7452C23.0029 20.7447 23.0034 20.7443 23.0038 20.7438C23.0043 20.7433 23.0048 20.7428 23.0053 20.7424L23.0065 20.7412C23.1641 20.5835 23.365 20.4949 23.5715 20.4749C23.8394 20.4481 24.1165 20.5365 24.3212 20.7412L24.3243 20.7443L29.6116 26.0317C29.9747 26.3947 29.9721 26.9859 29.609 27.349C29.246 27.712 28.6548 27.7146 28.2917 27.3516L23.6649 22.7248L19.0425 27.3472C18.6795 27.7102 18.0877 27.7071 17.7247 27.344Z",
    fill: "#538FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropupBtnIcon);
export default __webpack_public_path__ + "static/media/DropupBtnIcon.50406fb0.svg";
export { ForwardRef as ReactComponent };